module.exports = __webpack_public_path__ + "img/pr-15.4739b694.png";